export default __webpack_public_path__ + "static/media/logo.1f4b4ed4.png";